"use strict";
'use es6'; // OS

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.isMac = isMac;
exports.isEdge = isEdge;
exports.isFirefox = isFirefox;

function isMac() {
  return navigator.platform.toUpperCase().indexOf('MAC') >= 0;
} // Browser


function isEdge() {
  return window.navigator.userAgent.indexOf('Edge') >= 0;
}

function isFirefox() {
  return window.navigator.userAgent.indexOf('Firefox') >= 0;
}